import React from 'react';

const PageFlipIcon = ({
    width = 30,
    height = 30,
    fill = 'none',
    stroke = '#0053A0',
    className = '',
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 30 30"
            fill={fill}
            className={className}
        >
            <path
                d="M15 13.75H21.25M15 8.75H21.25M10 18.75V4.5C10 4.30109 10.079 4.11032 10.2197 3.96967C10.3603 3.82902 10.5511 3.75 10.75 3.75H25.5C25.6989 3.75 25.8897 3.82902 26.0303 3.96967C26.171 4.11032 26.25 4.30109 26.25 4.5V21.25C26.25 22.5761 25.7232 23.8479 24.7855 24.7855C23.8479 25.7232 22.5761 26.25 21.25 26.25"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.25 18.75H15.5C15.9137 18.75 16.2537 19.0838 16.2875 19.4963C16.4412 21.3938 17.225 26.25 21.25 26.25H7.5C6.50544 26.25 5.55161 25.8549 4.84835 25.1517C4.14509 24.4484 3.75 23.4946 3.75 22.5V21.25C3.75 20.587 4.01339 19.9511 4.48223 19.4822C4.95107 19.0134 5.58696 18.75 6.25 18.75Z"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default PageFlipIcon;
